import { render, staticRenderFns } from "./AnnotationSection.vue?vue&type=template&id=3ef44392&scoped=true&"
import script from "./AnnotationSection.vue?vue&type=script&lang=js&"
export * from "./AnnotationSection.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationSection.vue?vue&type=style&index=0&id=3ef44392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef44392",
  null
  
)

export default component.exports